

import {baseApi} from "@/api/base";
import { simpleVo,cateVo,infoVo } from "@/vo/bookVo";
import { simpleVo as exhibitionSimpleVo } from "@/vo/exhbitionVo";


export class getList extends baseApi{
	router="/book/list";
	method="get";
  conversion(response){   //转换器
    let list = [];
    for(let i in response.records){
      let vo = new simpleVo();
      vo.convert(response.records[i]);
      list.push(vo);
    }
    return {
      list:list,
      total:response.total
    };
  }
}

export class getCate extends baseApi{
	router="/book/cate";
	method="get";
  conversion(response){   //转换器
    let list = [];
    for(let i in response){
      let vo = new cateVo();
      vo.convert(response[i]);
      list.push(vo);
    }
    return list;
  }
}

export class getDetail extends baseApi{
	router="/book/info";
	method="get";
  conversion(response){   //转换器
    let vo = new infoVo();
    vo.convert(response);
    return vo;
  }
}

export class getExhibition extends baseApi{
  router="/book/exhibition";
  method="get";
  conversion(response){   //转换器
    let list = [];
    for(let i in response){
      let vo = new exhibitionSimpleVo();
      vo.convert(response[i]);
      list.push(vo);
    }
    return list;
  }
}



// WEBPACK FOOTER //
// ./src/api/book.js